// extracted by mini-css-extract-plugin
export default {"container":"Duty_container__da1Jd","manage":"Duty_manage__1GX97"};